import React, { useContext, useEffect } from 'react';
import { AppSettings } from '../../config/app-settings';
import { useListPlatformsQuery } from '../../redux/Api/PlatformApiSlice';
import LinksInsertion from '../../components/LinkInsertion/LinksInsertion';
import TextAreaInsertion from '../../components/LinkInsertion/TextAreaInsertion';
import Loader from '../pages/loader';
import { can } from '../../helpers/auth';
import NoPermission from '../pages/noPermission';

function LinkInsertionTiktok() {
	const { data: platforms, isLoading, isFetching } = useListPlatformsQuery({
		platform_name__icontains: 'Tiktok',
		page: '*',
		ordering: '-id',
		fields: ['id'].join(',')
	})

	const context = useContext(AppSettings);
	useEffect(() => {
		context.setAppHeaderNone(false);
		context.setAppSidebarNone(false);
		context.setAppContentClass('');
		context.setAppThemePanal(true)

		return function cleanUp() {
			context.setAppHeaderNone(true);
			context.setAppSidebarNone(true);
			context.setAppContentClass('p-0');
			context.setAppThemePanal(false)
		};
	}, []);

	if (!can("add_videourl")) {
        return <NoPermission />
    }
	
	return (
		<div className='flex flex-col gap-8'>
			<Loader isLoading={isLoading || isFetching}/>
			{platforms?.results ? <>
				<LinksInsertion
					platform_name="Tiktok"
					platformId={platforms?.results[0]?.id}
					matchText={[/tiktok\.com/]}
				/>
				<TextAreaInsertion
					platform_name="Tiktok"
					platformId={platforms?.results[0]?.id}
					matchText={[/tiktok\.com/]}
				/>
			</> : null}
		</div>
	)
}

export default LinkInsertionTiktok;